import { upsertStyleTag, removeStyleTag } from "../../domStyles";

const ROOT = document.documentElement;

const CLASS = "incluway-text-custom";
const VAR = "--incluway-text-color";
const STYLE_ID = "incluway-text-color-style";

const EXCLUDE = "#incluway-widget-root";

export function setTextColor(colorInput: unknown) {
  const color = String(colorInput ?? "").trim();

  if (!color) {
    disableTextColor();
    return;
  }

  upsertStyleTag(
    STYLE_ID,
    `
/* Base page text */
html.${CLASS} body {
  color: var(${VAR}) !important;
}

/* Common text elements only, exclude widget */
html.${CLASS} :is(
  p, span, a, li, dt, dd,
  label, small, strong, em, b, i,
  h1, h2, h3, h4, h5, h6,
  td, th, caption,
  blockquote, code, pre,
  button, input, textarea, select
):not(${EXCLUDE}):not(${EXCLUDE} *) {
  color: var(${VAR}) !important;
}

/* Keep widget untouched */
html.${CLASS} ${EXCLUDE} {
  color: initial !important;
}
`.trim(),
  );

  ROOT.style.setProperty(VAR, color);
  ROOT.classList.add(CLASS);
}

export function disableTextColor() {
  ROOT.classList.remove(CLASS);
  ROOT.style.removeProperty(VAR);
  removeStyleTag(STYLE_ID);
}
